import React from 'react'

function Footer() {
  return (
    <div style={{textAlign:"center", padding:"30px 0", borderTop:"1px solid #eee"}}>Copyright 2022. Ha Young Lee All rights reserved.</div>
  )
}

export default Footer